import CityPageToldos from "../components/CityPageToldos";

export default function ToldosFuengirola() {
  return (
    <CityPageToldos
      name="Fuengirola"
      slug="fuengirola"
      cp="29640"
      poblacion={87007}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5409}
      lng={-4.6261}
      zonas={["Los Boliches", "Centro", "Torreblanca del Sol", "Carvajal"]}
      landmarks={["Paseo Marítimo", "Puerto Deportivo", "Castillo Sohail"]}
      municipiosLimitrofes={["Mijas", "Benalmádena"]}
      festivalLocal="Feria del Rosario, primera semana de octubre"
      contextoTipologico="Altísima densidad de áticos y terrazas - mercado IDEAL para toldos. Edificios años 70-90 demandan reformas constantes."
      isCoreZone={true}
    />
  );
}